import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import TechImagePanel from '@/components/feature/TechImagePanel';
import Hero from './components/Hero';
import ChainDemo from './components/ChainDemo';

export default function JiuchouChain() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="九畴云铺业务主链 | 从一件商品开始的完整价值链"
        description="九畴云铺一条业务主链交互演示，从供应商创建商品、数字货架、云社员分发、消费者购买到平台清分与产业增值，形成消费到再消费的闭环。"
        keywords="九畴云铺,业务主链,价值链,数字货架,智能清分,产业增值"
        path="/jiuchou/chain"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '九畴云铺业务主链',
          description: '从一件商品开始的完整价值链',
        }}
      />
      <main>
        <Hero />
        <TechImagePanel
          eyebrow="业务主链"
          title="一件商品，一条价值链"
          desc="从供应商创建商品、数字货架上架、云社员分发，到消费者购买、平台清分与产业增值，一条主链贯通六阶段。"
          chips={['供应商', '数字货架', '云社员', '消费者', '清分', '产业']}
          stats={[
            { value: '6 阶段', label: '主链' },
            { value: '30 环节', label: '全链路' },
            { value: '1 闭环', label: '消费→再消费' },
          ]}
          imageUrl="https://readdy.ai/api/search-image?query=Abstract%20horizontal%20value%20chain%20ribbon%20of%20glowing%20nodes%2C%20deep%20dark%20ink%20navy%20background%2C%20emerald%20and%20gold%20light%20stream%20flowing%20left%20to%20right%20through%20supplier%20digital%20shelf%20cloud%20member%20consumer%20settlement%20and%20industry%20stages%2C%20digital%20commerce%20flow%2C%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1600&height=900&seq=jiuchou-panel-chain&orientation=landscape"
          imageAlt="九畴云铺 一条业务主链"
        />
        <ChainDemo />
      </main>
      <Footer />
    </div>
  );
}